import { createContext } from 'lib/createContext'
import React, { PropsWithChildren, useState } from 'react'

type Workflow = {
  open: () => void
  close: () => void
  isOpen: boolean
}

export type UserWorkProfileWorkflowsContextState = {
  addWorkerCredentialFlow: Workflow
}

const [
  UserWorkProfileWorkflowsContext,
  useUserWorkProfileWorkflowsContextValue,
] = createContext<UserWorkProfileWorkflowsContextState>({
  name: 'UserWorkProfileWorkflowsContext',
})

export const UserWorkProfileWorkflowsProvider = ({
  children,
}: PropsWithChildren) => {
  const [isAddWorkerCredentialFlowOpen, setIsAddWorkerCredentialFlowOpen] =
    useState(false)

  const value: UserWorkProfileWorkflowsContextState = {
    addWorkerCredentialFlow: {
      open: () => setIsAddWorkerCredentialFlowOpen(true),
      close: () => setIsAddWorkerCredentialFlowOpen(false),
      isOpen: isAddWorkerCredentialFlowOpen,
    },
  }

  return (
    <UserWorkProfileWorkflowsContext.Provider value={value}>
      {children}
    </UserWorkProfileWorkflowsContext.Provider>
  )
}

export { useUserWorkProfileWorkflowsContextValue }
